import { gql } from '@apollo/client';
import type { GallerySample } from 'graphql/rest-link/types';

export const GET_EVENT_GALLERY_SAMPLE = gql`
  query getEventGallerySample($galleryId: ID!) {
    getEventGallerySample(galleryId: $galleryId)
      @rest(
        type: "GallerySample"
        path: "/v2/api/photos/{args.galleryId}/sample"
        method: "GET"
        endpoint: "bff"
      ) {
      photos {
        id
        fileName
        status
        tags
        group
        photosAppPath
        thumbnailFile {
          uri
          type
        }
        processedFile {
          uri
          type
        }
      }
    }
  }
`;

export type GetEventGallerySampleVariables = {
  galleryId: string;
};

export type GetEventGallerySampleData = {
  getEventGallerySample: GallerySample;
};
